// @flow
import type {Node} from 'react'
import React from 'react'

import type {MoveItemsOptionMap, UpdateCallback} from 'components/proposals/types'
import CircleFooter from '../CircleV4Footer'
import RoleFooter from '../RoleV4Footer'
import V5Footer from '../V5Footer'

type Props = $ReadOnly<{
  changeKey: string,
  roleName: string,
  destroyCircle: boolean,
  destroyCircleKeepRole: boolean,
  destroyRole: boolean,
  expandRole: boolean,
  restructureCircle: boolean,
  isReadonly: boolean,
  isCircle: boolean,
  isOnV4: boolean,
  isNew: boolean,
  onChange: UpdateCallback,
  parentCircleName: string,
  policiesToMoveDown: MoveItemsOptionMap,
  rolesToMoveDown: MoveItemsOptionMap,
  policiesToMoveUp: MoveItemsOptionMap,
  rolesToMoveUp: MoveItemsOptionMap,
}>

const Footer = ({
  changeKey,
  roleName,
  destroyCircle,
  destroyCircleKeepRole,
  destroyRole,
  expandRole,
  restructureCircle,
  isReadonly,
  isCircle,
  isOnV4,
  isNew,
  onChange,
  parentCircleName,
  policiesToMoveDown,
  rolesToMoveDown,
  policiesToMoveUp,
  rolesToMoveUp,
}: Props): Node => {
  const v4Footer = () => (
    isCircle ? (
      <CircleFooter
        changeKey={changeKey}
        checked={destroyCircle}
        destroyCircleKeepRole={destroyCircleKeepRole}
        isReadonly={isReadonly}
        onChange={onChange}
        parentCircleName={parentCircleName}
        path={['destroyCircle']}
        policiesToMoveUp={policiesToMoveUp}
        rolesToMoveUp={rolesToMoveUp}
        roleName={roleName}
      />
    ) : (
      <RoleFooter
        changeKey={changeKey}
        expandRole={expandRole}
        destroyRole={destroyRole}
        isNew={isNew}
        isReadonly={isReadonly}
        onChange={onChange}
        policiesToMoveDown={policiesToMoveDown}
        rolesToMoveDown={rolesToMoveDown}
        roleName={roleName}
      />
    )
  )

  const v5Footer = () => (
    <V5Footer
      changeKey={changeKey}
      roleName={roleName}
      destroy={destroyRole || destroyCircle}
      moveItems={expandRole || restructureCircle}
      isReadonly={isReadonly}
      isCircle={isCircle}
      isNew={isNew}
      onChange={onChange}
      policiesToMoveDown={policiesToMoveDown}
      rolesToMoveDown={rolesToMoveDown}
      policiesToMoveUp={policiesToMoveUp}
      rolesToMoveUp={rolesToMoveUp}
    />
  )

  return isOnV4 ? v4Footer() : v5Footer()
}

export default Footer
